import React from 'react';

import { ImportCard } from './ImportCard';

interface Props {
  /** In order; the number shown is the position. */
  steps: string[];
  testId?: string;
  /** A last row under the steps, inside the same card (e.g. a download link). */
  footer?: React.ReactNode;
}

/** Numbered how-to rows. */
export function InstructionSteps({ steps, testId, footer }: Props) {
  return (
    <ImportCard data-testid={testId}>
      <ol className="divide-y divide-gray-100 dark:divide-gray-700">
        {steps.map((step, index) => (
          <li key={step} className="flex items-start gap-3 px-4 py-3">
            <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-primary-500 text-sm font-bold text-white">
              {index + 1}
            </span>
            <span className="pt-0.5 text-base font-medium leading-6 text-gray-900 dark:text-white">
              {step}
            </span>
          </li>
        ))}
      </ol>
      {footer && (
        <div className="border-t border-gray-100 px-4 py-3 dark:border-gray-700">
          {footer}
        </div>
      )}
    </ImportCard>
  );
}
